import { html } from "src/components/HtmlViewer/utils";
import * as GQL from "src/types/graphql";

export const WAITLISTED = {
  type: GQL.message_template_type_enum.Waitlisted,
  emailSubject:
    "You are on the waitlist at {{waitlist.schoolName}} / Estás en la lista de espera de {{waitlist.schoolName}}",
  emailHtml: html`<p>
      Dear {{parent.name}},<br />
      <br />
      {{student.name}} is on the waitlist at {{waitlist.schoolName}} for grade
      {{grade}} for the {{enrollmentPeriod.name}}!<br />
      <br />
      Please log in to review your waitlist position {{applyUrl}}<br />
      If you need help, please contact {{organization.name}}.<br />
      <br />
      -{{organization.name}} Team<br />
    </p>
    <p>_____________________________________________</p>
    <p>
      Estimado/a {{parent.name}},<br />
      <br />
      {{student.name}} está en la lista de espera en {{waitlist.schoolName}}
      para el grado {{grade}} para el {{enrollmentPeriod.name}}.<br />
      <br />
      Por favor, inicie sesión para revisar su posición en la lista de espera
      {{applyUrl}}<br />
      Si necesita ayuda, por favor contacte a {{organization.name}}.<br />
      <br />
      -Equipo de {{organization.name}}<br />
    </p>`,
  emailText: `Dear {{parent.name}},

{{student.name}} is on the waitlist at {{waitlist.schoolName}} for grade {{grade}} for the {{enrollmentPeriod.name}}!

Please log in to review your waitlist position {{applyUrl}}
If you need help, please contact {{organization.name}}.

-{{organization.name}} Team

_____________________________________________

Estimado/a {{parent.name}},

{{student.name}} está en la lista de espera en {{waitlist.schoolName}} para el grado {{grade}} para el {{enrollmentPeriod.name}}.

Por favor, inicie sesión para revisar su posición en la lista de espera {{applyUrl}}
Si necesita ayuda, por favor contacte a {{organization.name}}.

-Equipo de {{organization.name}}`,
  sms: "{{student.name}} is on the waitlist at {{waitlist.schoolName}}. Log in to review it {{applyUrl}} / {{student.name}} está en la lista de espera de {{waitlist.schoolName}}. Inicie sesión para revisarlo {{applyUrl}}",
};
